import React from 'react';
import { ActivityIcon, GiftIcon } from 'lucide-react';
import { bonuses, volumes } from '../data/content';
export function ProductIntro() {
  return <section className="bg-white px-4 py-6 text-center md:px-12 md:py-8" data-id="element-177" data-mp="22jc1v80aua4w">
      <h2 className="mx-auto max-w-[620px] text-[19px] font-extrabold uppercase leading-[1.2] tracking-[-0.2px] text-blue-950 md:text-[24px]" data-id="element-178" data-mp="1npfubbbyxliq">
        The complete 7-in-1 postoperative shoulder rehabilitation system
      </h2>
      <p className="mt-1.5 text-[24px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-teal-700 md:text-[34px]" data-id="element-179" data-mp="2gewks3g12scb">
        <ActivityIcon className="mr-2 inline h-6 w-6 -translate-y-1 text-amber-400 md:h-8 md:w-8" strokeWidth={2.5} aria-hidden data-id="element-180" data-mp="26na0lhlppixf" />
        Complete Postoperative Shoulder Rehabilitation System™
      </p>
      <p className="mx-auto mt-1.5 max-w-[600px] text-[12px] font-bold uppercase leading-tight tracking-[0.04em] text-amber-700 md:text-[13px]" data-id="element-181" data-mp="2zbxq5pdhuugs">
        Advanced, practical clinical resources for physical therapists specializing in musculoskeletal and postoperative
        rehabilitation
      </p>
      <p className="mx-auto mt-1.5 max-w-[600px] text-[13px] leading-[1.35] text-slate-600 md:text-[14px]" data-id="element-182" data-mp="pgu4plbn0luu">
        Rotator Cuff Repair • Shoulder Stabilization • Biceps Procedures • Shoulder Arthroplasty • Fracture Fixation •
        Advanced Reconstruction • Functional Recovery
      </p>
      <p className="mt-1 text-[12px] font-extrabold uppercase text-teal-700 md:text-[13px]" data-id="element-183" data-mp="1d5wniwi0ckqx">
        7 Advanced Clinical Volumes + 5 FREE Professional Bonuses
      </p>

      <h3 className="mt-5 text-[15px] font-extrabold uppercase leading-tight text-blue-950 md:text-[17px]" data-id="element-184" data-mp="189690dlupx7m">
        Your collection includes
      </h3>
      <div className="mt-3 grid gap-5 text-left sm:grid-cols-2 sm:gap-8" data-id="element-185" data-mp="1i4zuwnlgn322">
        <div data-id="element-186" data-mp="3ovfrlveedko5">
          <h4 className="flex items-center gap-1.5 text-[12px] font-extrabold uppercase tracking-[0.06em] text-teal-700 md:text-[13px]" data-id="element-187" data-mp="3ov7dy1agabbw">
            <ActivityIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden data-id="element-188" data-mp="3jy77vqdlp8ks" />
            The 7 volumes
          </h4>
          <ol className="mt-2 space-y-1.5 text-[14px] leading-[1.35] text-slate-600 md:text-[15px]" data-id="element-189" data-mp="dhgsrb5zg2rr">
            {volumes.map(v => <li key={v.number} className="flex gap-2" data-id="element-190" data-mp="mfixa0oxddjs">
                <span className="w-5 shrink-0 font-extrabold text-blue-950" data-id="element-191" data-mp="mi5581fq9v2j">{v.number}</span>
                <span data-id="element-192" data-mp="rgggmglo8dmv">{v.title}</span>
              </li>)}
          </ol>
        </div>
        <div data-id="element-193" data-mp="wdztpd6mukd8">
          <h4 className="flex items-center gap-1.5 text-[12px] font-extrabold uppercase tracking-[0.06em] text-amber-700 md:text-[13px]" data-id="element-194" data-mp="wcf9ohhy2jtm">
            <GiftIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden data-id="element-195" data-mp="156a3itdm8nty" />
            The 5 free bonuses
          </h4>
          <ol className="mt-2 space-y-1.5 text-[14px] leading-[1.35] text-slate-600 md:text-[15px]" data-id="element-196" data-mp="1a4bmleb1kn5f">
            {bonuses.map(b => <li key={b.number} className="flex gap-2" data-id="element-197" data-mp="1f2wnlfy4baux">
                <span className="w-5 shrink-0 font-extrabold text-blue-950" data-id="element-198" data-mp="1k4vp0kaarxp8">{b.number}</span>
                <span data-id="element-199" data-mp="34mwi6paqzgl8">{b.title}</span>
              </li>)}
          </ol>
        </div>
      </div>

      <div className="mt-5 border-t border-slate-200 pt-3" data-id="element-200" data-mp="2zlz34ll1b2ny">
        <p className="text-[18px] font-extrabold uppercase leading-tight text-blue-950 md:text-[22px]" data-id="element-201" data-mp="2unfe2cb59ard">
          12 professional resources. 480 pages.
        </p>
        <p className="mt-1 text-[12px] font-extrabold uppercase text-teal-700 md:text-[14px]" data-id="element-202" data-mp="2pqp0bvmtar94">
          Practical clinical materials organized by surgical procedure
        </p>
      </div>
    </section>;
}